module.exports = __webpack_public_path__ + "img/logo-login.949a75c9.png";